import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/nwapp/price`;

class PriceService {
  getProgramOptionField(fileData) {
    return axios
      .post(`${API_URL}/ProgramOptionField`, fileData, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  investorPricingByFileData(fileData) {
    return axios
      .post(`${API_URL}/InvestorPricingByFileData`, fileData, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  investorMultiPricing(loanNumbers, investorIds) {
    return axios
      .post(
        `${API_URL}/InvestorMultiPricing`,
        { loanNumbers: loanNumbers, investorIds: investorIds },
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getLoanPadding(loanNumber) {
    return axios
      .get(`${API_URL}/LoanPadding/loanNumber/${loanNumber}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getBrokerPadding(organizationId) {
    return axios
      .get(`${API_URL}/BrokerPadding/OrganizationId/${organizationId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new PriceService();
